/*
 *  Created by SGiri 03/12/2018
 */

import { Injectable } from '@angular/core';
import { CommonService } from '~util/common.service';
import { AdminConstant } from '~admin/util/admin.constant';
import { BI_HttpService } from '../../services/http.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class AdminService {

  constructor(private http: BI_HttpService, private commonService: CommonService) {
  }

  public getRequests() {
    return this.http.get(AdminConstant.GET_REQUEST_URL);
  }

  public delete(request) {
    return this.http.post(AdminConstant.GET_REQUEST_URL, request);
  }

  public deny(request) {
    return this.http.post(AdminConstant.REQ_DENY_URL, request);
  }

  public approve(request) {
    return this.http.post(AdminConstant.REQ_APPROVE_URL, request);
  }

  public rollback(request) {
    return this.http.post(AdminConstant.REQ_ROLLBACL_URL, request);
  }

  public getEnvironments() {
    return this.http.get(AdminConstant.GET_ENVIRONMENT_URL);

  }

  public getContent(environmentID, isTarget) {
    return this.http.get(AdminConstant.GET_CONTENT_URL + environmentID + '/' + isTarget);
  }

  public getUserFolders(environmentID, isTarget, username): Observable<any> {
    return this.http.get(AdminConstant.GET_USER_DATA + environmentID + '/' + isTarget + '/' + username);
  }

  public getAllUser(environmentID): Observable<any> {
    return this.http.get(AdminConstant.GET_ENVIRONMENT_USERS_URL + environmentID);
  }
  public process(request) {
    return this.http.post(AdminConstant.REQ_CREATE_URL, request);
  }

  public create(request) {
    return this.http.post(AdminConstant.CREATE_DATASOURCE_URL, request);
  }

  public setUserRole() {
    if (!this.commonService.userRole) {
      this.http.getNoError(AdminConstant.GET_ROLES_URL + '/' + this.commonService.environment).subscribe((userRole: any) => {
        this.commonService.userRole = userRole.role;
      });
    }
  }

  public bulkCreate(formData: FormData) {
    return this.http.post(AdminConstant.CREATE_BULK_DATASOURCE_URL, formData);
  }

  public getSampleJson() {
    return this.http.getAssets('SampleJson_BulkUpdate.json');
  }

  public getConciseDatasources() {
    return this.http.get(AdminConstant.GET_CONCISE_DATASOURCES_URL);
  }

}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-admin/services/admin.service.ts